import { ProgramEnvironment } from "../types/program";

export const ProgramEnvironmentToNameMap: Record<ProgramEnvironment, string> = {
  ONLINE: "Online",
  HYBRID: "Hybrid",
  IN_PERSON: "In person",
};

export const getSubmitCta = <
  Program extends {
    customCtaCopy?: string | null;
  },
>(
  program: Program | null
): string => {
  return program?.customCtaCopy ? program.customCtaCopy : "Agree & submit";
};

export const getNextCta = (): string => {
  return "Agree & next";
};
